import React, { createContext, useEffect, useState } from "react";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { router } from "./routes/routes";
import LoaderComponent from "./components/loader/loader";

export interface IAppContextState {
  isCollapsedSidebarState: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>
  ];
  quranrtModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  haziraModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  hishabpatiModalState: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>
  ];
  nexoModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  bftiModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  agency1ModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  ezazSinglePageModalState: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>
  ];
  huntModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  warmPawsModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
  plateShareModalState: [
    boolean,
    React.Dispatch<React.SetStateAction<boolean>>
  ];
  goptsModalState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
}

export const AppContext = createContext<IAppContextState | null>(null);

function App() {
  const [isCollapsedSidebar, setIsCollapsedSidebar] = useState(false);
  const [isOpenQuranrtModal, setOpenQuranrtModal] = useState(false);
  const [isOpenHaziraModal, setOpenHaziraModal] = useState(false);
  const [isOpenHishabpatiModal, setOpenHishabpatiModal] = useState(false);
  const [isOpenNexoModal, setOpenNexoModal] = useState(false);
  const [isOpenBftiModal, setOpenBftiModal] = useState(false);
  const [isOpenAgency1Modal, setOpenAgency1Modal] = useState(false);
  const [isOpenEzazSinglePageModal, setOpenEzazSinglePageModal] =
    useState(false);
  const [isOpenHuntModal, setOpenHuntModal] = useState(false);
  const [isOpenWarmPawsModal, setOpenWarmPawsModal] = useState(false);
  const [isOpenPlateShareModal, setOpenPlateShareModal] = useState(false);
  const [isOpenGoptsModal, setOpenGoptsModal] = useState(false);

  const [loading, setLoading] = useState(true); // Loading state

  useEffect(() => {
    const handleLoadComplete = () => {
      setLoading(false);
    };

    if (document.readyState === "complete") {
      handleLoadComplete();
    } else {
      window.addEventListener("load", handleLoadComplete);
    }

    return () => {
      window.removeEventListener("load", handleLoadComplete);
    };
  }, []);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 768px)");

    const handleMediaQueryChange = (e: MediaQueryListEvent) => {
      setIsCollapsedSidebar(e.matches);
    };

    if (mediaQuery.matches) {
      setIsCollapsedSidebar(true);
    }

    mediaQuery.addEventListener("change", handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
    };
  }, []);

  if (loading) {
    return <LoaderComponent></LoaderComponent>;
  }

  return (
    <AppContext.Provider
      value={{
        isCollapsedSidebarState: [isCollapsedSidebar, setIsCollapsedSidebar],
        quranrtModalState: [isOpenQuranrtModal, setOpenQuranrtModal],
        haziraModalState: [isOpenHaziraModal, setOpenHaziraModal],
        hishabpatiModalState: [isOpenHishabpatiModal, setOpenHishabpatiModal],
        nexoModalState: [isOpenNexoModal, setOpenNexoModal],
        bftiModalState: [isOpenBftiModal, setOpenBftiModal],
        agency1ModalState: [isOpenAgency1Modal, setOpenAgency1Modal],
        ezazSinglePageModalState: [
          isOpenEzazSinglePageModal,
          setOpenEzazSinglePageModal,
        ],
        huntModalState: [isOpenHuntModal, setOpenHuntModal],
        warmPawsModalState: [isOpenWarmPawsModal, setOpenWarmPawsModal],
        plateShareModalState: [isOpenPlateShareModal, setOpenPlateShareModal],
        goptsModalState: [isOpenGoptsModal, setOpenGoptsModal],
      }}
    >
      <RouterProvider router={router} />
    </AppContext.Provider>
  );
}

export default App;
